export default {
    tab_title: 'Oferte Cash Club',
    sub_title: 'Filtru Oferte Cash Club',
    list_title: 'Lista Oferte Cash Club',
    filters: {
        partner: 'Partener',
        campaign_status: 'Stare campanie',
        campaign_status_active: 'Activă',
        campaign_status_expired: 'Expirată',
        campaign_status_not_set: 'Neasignată',
    },
    table: {
        image: 'Imagine',
        name: 'Nume ofertă',
        value: 'Valoare',
        category: 'Categorie',
        sync: 'Sincronizare',
        url: 'Link ofertă',
        brand: 'Brand',
        campaign: 'Campanie',
    },
    edit_page: {
        edit_title: 'Modifică oferta Cash Club',
        offer_name: 'Nume ofertă',
        partner: 'Partener',
        brand: 'Brand',
        campaign: 'Campanie',
        campaign_code: 'Cod campanie',
        discount_percentage: 'Procent reducere',
        start_from: 'Data început',
        end_from: 'Data sfârșit',
        description: 'Descriere ofertă',
        instructions: 'Instrucțiuni ofertă',
    }
}